import React from "react";

const BannerComponent = (props) => <div>{props.data}</div>;

export default BannerComponent;
